import { MessageTemplate } from '@/features/messages/MessageTemplate';
import { DriverMessage } from '@/features/messages/DriverMessage';
import { TransportType } from '@/features/shared/models/TransportType';

export const IDriverMessagesApiId = Symbol.for('IDriverMessagesApiId');

export interface IDriverMessagesApi {
    /**
     * Fetch templates
     */
    getTemplates(transportType: TransportType): Promise<MessageTemplate[]>;

    /**
     * Send message
     */
    sendMessage(message: DriverMessage): Promise<void>;
}
